module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/bd10f8b6da88cc7a3db7829fbc9dfa3a.png";